import bootbox from 'bootbox';

export default class BootboxHelper {

    static alert(message, opt) {
        opt = opt || {};
        return new Promise(function (resolve, reject) {
            const isModalOpen = document.body.classList.contains('modal-open');
            bootbox.alert({
                ...opt,
                animate: false,
                message: message,
                callback: function () {
                    resolve();
                    if (isModalOpen) {
                        setTimeout(() => {
                            document.body.classList.add('modal-open');
                        }, 0);
                    }
                }
            });
        });
    }

    static confirm(message, opt) {
        opt = opt || {};
        return new Promise(function (resolve, reject) {
            const isModalOpen = document.body.classList.contains('modal-open');
            bootbox.confirm({
                ...opt,
                animate: false,
                buttons: {
                    cancel: {
                        className: 'me-auto',
                        label: 'No'
                    },
                    confirm: {
                        label: 'ms-auto',
                        label: 'Yes'
                    }
                },
                message: message,
                callback: function (result) {
                    resolve(result);
                    if (isModalOpen) {
                        setTimeout(() => {
                            document.body.classList.add('modal-open');
                        }, 0);
                    }
                }
            });
        });
    }

    static prompt(title, opt) {
        opt = opt || {};
        return new Promise(function (resolve, reject) {
            const isModalOpen = document.body.classList.contains('modal-open');
            bootbox.prompt({
                ...opt,
                animate: false,
                title: title,
                callback: function (result) {
                    resolve(result);
                    if (isModalOpen) {
                        setTimeout(() => {
                            document.body.classList.add('modal-open');
                        }, 0);
                    }
                }
            });
        });
    }

}

